import { useAuth } from 'context/AuthProvider.js';
import { httpClient } from 'helpers/HttpClient.js';
import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, FormControl, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { ApiEndpoint } from 'helpers/ApiEndPoint.js';
import PropTypes from 'prop-types';
const URI = ApiEndpoint + 'configuration/';

const EditTipoStatus = ({ idTipoStatus, closeModal }) => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [tipoStatus, setTipoStatus] = useState({
    descripcion: ''
  });
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors }
  } = useForm();

  const getTipoStatus = async () => {
    setTipoStatus(null);

    httpClient('GET', URI + 'tiposstatus/' + idTipoStatus, {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          setValue('descripcion', response.data.descripcion);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };

  const onSubmit = data => {
    console.log(data);

    if (idTipoStatus > 0) {
      httpClient(
        'put',
        URI + 'tiposstatus/' + idTipoStatus,
        {
          descripcion: data.descripcion,
          idusuario: 1
        },
        userData.token
      )
        .then(function (response) {
          if (!response.data.error) {
            closeModal();
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {});
    } else {
      httpClient(
        'POST',
        URI + 'tiposstatus',
        {
          descripcion: data.descripcion,
          idusuario: 1
        },
        userData.token
      )
        .then(function (response) {
          if (!response.data.error) {
            closeModal();
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {});
    }
  };
  useEffect(() => {
    if (idTipoStatus > 0) getTipoStatus();
  }, []);

  return (
    <Card style={{ width: '100%' }}>
      <Card.Body>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Col>
              <Form.Group className="mb-4">
                <Form.Label>Descripcion</Form.Label>
                <FormControl
                  {...register('descripcion', {
                    required: 'Descripcion es requerido',
                    minLength: {
                      value: 3,
                      message: 'Descripcion debe tener al menos 4 caracteres'
                    },
                    maxLength: {
                      value: 30,
                      message: 'Descripcion debe tener máximo 30 caracteres'
                    }
                  })}
                  type="text"
                  defaultValue={tipoStatus?.descripcion}
                  isInvalid={!!errors.descripcion}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.descripcion?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col>
              <Button type="submit" color="primary" size="sm">
                Guardar
              </Button>
            </Col>
          </Row>
        </Form>
      </Card.Body>
    </Card>
  );
};
EditTipoStatus.propTypes = {
  idTipoStatus: PropTypes.number.isRequired,
  closeModal: PropTypes.func
};
export default EditTipoStatus;
